export function mainMenu() {
  const toggleMenuButton = document.querySelectorAll('[data-js="toggle-menu"]'); // Burger button
  const mainMenu = document.querySelector("#mainMenu"); // Select the main menu

  function updateMenuAriaHidden() {
    // Convert 1480px to rems (assuming 1rem = 16px)
    const remBreakpoint = 1480 / 16; // 85.375
    const currentRem = window.innerWidth / parseFloat(getComputedStyle(document.documentElement).fontSize);

    if (currentRem < remBreakpoint) {
      mainMenu.setAttribute("aria-hidden", "true");
      mainMenu.setAttribute("inert", "");
      // Make toggle buttons focusable on small screens
      toggleMenuButton.forEach(btn => {
      btn.removeAttribute("tabindex");
      btn.removeAttribute("aria-hidden");
      });
    } else {
      mainMenu.removeAttribute("aria-hidden");
      mainMenu.removeAttribute("inert");
      // Remove toggle buttons from tab order on large screens (not focusable)
      toggleMenuButton.forEach(btn => {
      btn.setAttribute("tabindex", "-1");
      btn.setAttribute("aria-hidden", "true");
      });
    }
  }
  updateMenuAriaHidden();
  // Debounced resize handler (100ms)
  function debounce(fn, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  window.addEventListener("resize", debounce(updateMenuAriaHidden, 100));
  // const menuTogglers = mainMenu.querySelectorAll('[aria-controls]');
  const listItems = mainMenu.querySelectorAll("li"); // Select all list items

toggleMenuButton.forEach(button => {
  button.addEventListener("click", () => {
    // Add event listener to the burger button
    const expanded = button.getAttribute("aria-expanded") === "true";
    mainMenu.setAttribute("aria-hidden", expanded ? "true" : "false");
    if (expanded) {
      mainMenu.setAttribute('inert', '');
    } else {
      mainMenu.removeAttribute('inert');
    }
    toggleMenuButton.forEach(btn => {
        btn.setAttribute("aria-expanded", expanded ? "false" : "true");
    });
  });
});


// Utility for touch detection
function isTouchDevice() {
  return (
    ('ontouchstart' in window) ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function shouldCloseOthers() {
  const remBreakpoint = 1480 / 16; // 92.5
  const currentRem = window.innerWidth / 16;
  return currentRem >= remBreakpoint && isTouchDevice();
}

// Helper to close all other open submenus except the current one
function closeOtherSubmenus(currentMenuItem) {
  document.querySelectorAll(".mainnav__li").forEach(function (menuItem) {
    if (menuItem === currentMenuItem) return;
    var link = menuItem.querySelector(".mainnav__link > a[aria-controls]");
    var chevronBtn = menuItem.querySelector(".mainnav__link > button[aria-controls]");
    var submenu = menuItem.querySelector(".mainnav__submenu");
    if (!link || !submenu) return;
    if (link.getAttribute("aria-expanded") === "true") {
      link.setAttribute("aria-expanded", "false");
      chevronBtn && chevronBtn.setAttribute("aria-expanded", "false");
      // submenu.hidden = true;
      submenu.setAttribute("inert", "");
    }
  });
}

document.querySelectorAll(".mainnav__li").forEach(function (menuItem) {
  var link = menuItem.querySelector(".mainnav__link > a[aria-controls]");
  var chevronBtn = menuItem.querySelector(".mainnav__link > button[aria-controls]");
  var submenu = menuItem.querySelector(".mainnav__submenu");

  if (!link || !submenu) return;

  function openMenu(focusFirst) {
    // NEW: close others if needed
    if (shouldCloseOthers()) {
      closeOtherSubmenus(menuItem);
    }
    link.setAttribute("aria-expanded", "true");
    chevronBtn && chevronBtn.setAttribute("aria-expanded", "true");
    // submenu.hidden = false;
    submenu.removeAttribute("inert");
    if (focusFirst) {
      var firstLink = submenu.querySelector("a, button, [tabindex]:not([tabindex='-1'])");
      if (firstLink) firstLink.focus();
    }
  }

  function closeMenu(focusTarget) {
    link.setAttribute("aria-expanded", "false");
    chevronBtn && chevronBtn.setAttribute("aria-expanded", "false");
    // submenu.hidden = true;
    submenu.setAttribute("inert", "");
    if (focusTarget) focusTarget.focus();
  }

  function isMenuOpen() {
    return link.getAttribute("aria-expanded") === "true";
  }

  // --- Keyboard handling for top link ---
  link.addEventListener("keydown", function (e) {
    if ((e.key === "ArrowDown" || e.key === " " || e.key === "Spacebar") && !isMenuOpen()) {
      e.preventDefault();
      openMenu(true);
    } else if (e.key === "ArrowUp" && !isMenuOpen()) {
      e.preventDefault();
      openMenu(true);
      var links = submenu.querySelectorAll("a, button, [tabindex]:not([tabindex='-1'])");
      if (links.length) links[links.length - 1].focus();
    }
  });

  // --- Chevron button click (touch devices) ---
  if (chevronBtn) {
    chevronBtn.addEventListener("click", function () {
      if (isMenuOpen()) {
        closeMenu(chevronBtn);
      } else {
        openMenu(true);
      }
    });

    chevronBtn.addEventListener("keydown", function (e) {
      if ((e.key === "ArrowDown" || e.key === " " || e.key === "Spacebar") && !isMenuOpen()) {
        e.preventDefault();
        openMenu(true);
      } else if (e.key === "ArrowUp" && !isMenuOpen()) {
        e.preventDefault();
        openMenu(true);
        var links = submenu.querySelectorAll("a, button, [tabindex]:not([tabindex='-1'])");
        if (links.length) links[links.length - 1].focus();
      }
    });
  }

  // --- Submenu keyboard navigation ---
  submenu.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      e.preventDefault();
      closeMenu(link);
    }
  });

  // --- Hover only on devices that really support hover ---
  const supportsHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  const remBreakpoint = 1480 / parseFloat(getComputedStyle(document.documentElement).fontSize);
  const currentRem = window.innerWidth / parseFloat(getComputedStyle(document.documentElement).fontSize);

  if (supportsHover && currentRem >= remBreakpoint) {
    menuItem.addEventListener("mouseenter", function () {
      if (!isMenuOpen()) openMenu(false);
    });
    menuItem.addEventListener("mouseleave", function () {
      if (isMenuOpen()) closeMenu();
    });

    function handleFocusOut(e) {
      const byKeyboard = (e.relatedTarget !== null);
      if (!byKeyboard) return;
      setTimeout(function () {
        const active = document.activeElement;
        if (
          !submenu.contains(active) &&
          active !== link &&
          (!chevronBtn || active !== chevronBtn)
        ) {
          closeMenu();
        }
      }, 10);
    }

    link.addEventListener("focusout", handleFocusOut);
    submenu.addEventListener("focusout", handleFocusOut);
    if (chevronBtn) chevronBtn.addEventListener("focusout", handleFocusOut);
  }
});

document.querySelectorAll('[aria-controls="search-dialog"]').forEach(btn => {
  const dialog = document.querySelector('#search-dialog');
  if (!dialog) return;

  function openDialog() {
    dialog.showModal();
    dialog.classList.add('is-open');
    document.querySelectorAll('[aria-controls="search-dialog"]').forEach(btns => {
      btns.setAttribute('aria-expanded', 'true');
    })
    dialog.setAttribute('aria-hidden', 'false');
    const firstInput = dialog.querySelector('input, [tabindex]:not([tabindex="-1"])');
    if (firstInput) firstInput.focus();
  }

  function closeDialog() {
    dialog.classList.remove('is-open');
    setTimeout(() => {
      dialog.close();
      document.querySelectorAll('[aria-controls="search-dialog"]').forEach(btns => {
        btns.setAttribute('aria-expanded', 'false');
      })
      dialog.setAttribute('aria-hidden', 'true');
      btn.focus();
    }, 300)
  }

  btn.addEventListener('click', () => {
    if (btn.getAttribute('aria-expanded') === 'true') {
      closeDialog();
    } else {
      openDialog();
    }
  });

  dialog.addEventListener('close', () => {
    document.querySelectorAll('[aria-controls="search-dialog"]').forEach(btns => {
      btns.setAttribute('aria-expanded', 'false');
    })
    dialog.setAttribute('aria-hidden', 'true');
  });
});

};
